var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.path)?_c('div',{staticClass:"buttonFloat",class:{disabled: _vm.path === 'null'},on:{"click":_vm.redirect}},[_c('i',{class:_vm.icon})]):_c('div',{staticClass:"buttonFloat",on:{"click":_vm.clickEvent}},[_c('i',{class:_vm.icon})])}
var staticRenderFns = []

export { render, staticRenderFns }